import { Component, OnInit, Input, AfterContentInit, ViewChild } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { ApiService } from 'src/app/services/api.service';
import { ValidatorService } from 'src/app/services/validator.service';

declare var $:any;

@Component({
  selector: 'produto-venda-offline',
  templateUrl: './produto-venda-offline.component.html',
  styleUrls: ['./produto-venda-offline.component.scss']
})
export class ProdutoVendaOfflineComponent implements OnInit,AfterContentInit {

  @Input("servico") servico:any               = {};
  @Input("configuracaoLoja") configuracaoLoja = null;  
  public dataItem:any                         = {}; 
  public qtd_adt                              = 1;
  public loader                               = false; 
  public message = {
    data: "",
    class: "",
    show: false 
  };
  public messageLoader = "Enviando Solicitação. Aguarde!"; 
  @ViewChild("dataChegada") dataChegada = null;
  @ViewChild("dataPartida") dataPartida = null;

  constructor(
    public app: AppService,
    public api: ApiService,
    public validator: ValidatorService
  ){ }
  
  /***
   * 
   * Send
   * 
   */
  send(){

    try{

      this.validator.clear();
      this.validator.isEmpty(this.dataItem.nome,"nome","- Informe o Nome.");
      this.validator.isEmpty(this.dataItem.email,"email","- Informe o E-mail.");
      this.validator.isEmail(this.dataItem.email,"email","- O E-mail informado é inválido.");
      this.validator.isEmpty(this.dataItem.data_chegada,"data_chegada","- Informe a Data de Chegada.");
      //this.validator.isDate(this.dataItem.data_chegada,"data_chegada","- Data de Chegada não é válida. Informe uma data válida.");
      this.validator.isEmpty(this.dataItem.data_partida,"data_partida","- Informe a Data de Partida.");
      //this.validator.isDate(this.dataItem.data_partida,"data_partida","- Data de Partida não é válida. Informe uma data válida.");

      if(!this.validator.passes()){

        this.app.info(this.validator.getMessagesHtml());
        return false;
      }
      this.loader = true;

      this.api.produto().solicitacao_reserva(this.dataItem).subscribe((response) => {

        this.loader = false;

        switch(response.status){
          case 1:
            this.app.info("Seus dados foram enviados com sucesso. Em breve entraremos em contato.","success");
            this.initDataItem();
          break;
          case 0:
            let errors = this.app.getErrors([response.data]);
            this.app.info(errors,"danger");
          break;
          default:

            this.app.info("Houve um erro interno. Tente mais tarde ou informe nossa equipe.","danger");
            
          break;
        }


      }, (response) => {

        this.loader = false;

        let error          = this.app.formatError(response);

        this.loader        = false;
        this.app.info(error.message,"danger");

      });
      

    }catch(e){

      this.loader = false;


    }

  }
  /**
   * 
   * Inicializa o dataItem
   * 
   */
  initDataItem(){

    this.dataItem = {
      nome: "",
      email: "",
      telefone: "",
      produto: this.servico.nome,
      messagem: "",
      qtd_adultos: 1,
      qtd_melhor_idade: 0,
      qtd_criancas_pagantes: 0,
      qtd_criancas_cortesia: 0,
      data_chegada: "",
      data_partida: ""
    }
    
  }
  /**
   * 
   * Change dates
   * 
   **/
   changeDates(data){
    
    this.dataItem.data_chegada  = data.date_in;
    this.dataItem.data_partida = data.date_out;  

  }
  /**
   * 
   * Set labels
   * 
   */
  setLabels(){

    if(this.servico.passageiro_label_informar){

      this.configuracaoLoja.passageiro_label_adt      = this.servico.passageiro_label_adt;
      this.configuracaoLoja.passageiro_label_chd      = this.servico.passageiro_label_chd;
      this.configuracaoLoja.passageiro_label_snr      = this.servico.passageiro_label_snr;
      this.configuracaoLoja.passageiro_label_chd_free = this.servico.passageiro_label_chd_free;

    }

  }
  /**
   * 
   * Adiciona
   * 
   */
  mais(campo){

    switch(campo){
      case 'adt':
        this.dataItem.qtd_adultos++;
      break;
      case 'chd':
        this.dataItem.qtd_criancas_pagantes++;
      break;
      case 'snr':
        this.dataItem.qtd_melhor_idade++;
      break;
      case 'inf':
        this.dataItem.qtd_criancas_cortesia++;
      break;
    }

  }
  /**
   * 
   * Diminui
   * 
   */
  menos(campo){
    
    switch(campo){
      case 'adt':
        if(this.dataItem.qtd_adultos > 1){
          this.dataItem.qtd_adultos--;
        }  
      break;
      case 'chd':
        if(this.dataItem.qtd_criancas_pagantes >= 1){
          this.dataItem.qtd_criancas_pagantes--;
        }  
      break;
      case 'snr':
        if(this.dataItem.qtd_melhor_idade >= 1){
          this.dataItem.qtd_melhor_idade--;
        }  
      break;
      case 'inf':
        if(this.dataItem.qtd_criancas_cortesia >= 1){
          this.dataItem.qtd_criancas_cortesia--;
        }  
      break;
    }

  }
  /**
   * 
   * Config Dates
   * 
   */
  configDates(){
  
    if(this.dataChegada != null && this.dataChegada != undefined){

      $(this.dataChegada.nativeElement).datepicker({
        dateFormat: "dd/mm/yy",
        minDate: new Date(),
        changeMonth: true,
        changeYear: false,  
        monthNamesShort: ['Janeiro','Fevereiro','Março','Abril','Maio','junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
        dayNamesMin: ['Dom','Seg','Ter','Qua','Qui','Sex','Sab'],
        monthNames: ['Janeiro','Fevereiro','Março','Abril','Maio','junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
        showOn: "both",
        buttonImageOnly: true,
        buttonImage: "/images/icons/calendar-01.svg", 
        onSelect: (value)=>{
        
        let data   = $(this.dataChegada.nativeElement).val();
        this.dataItem.data_chegada = data;
        $(this.dataPartida.nativeElement).datepicker("option","minDate",data); 
        setTimeout(() => {
          $(this.dataPartida.nativeElement).datepicker("show");  
        },500); 
                        
        }
  
      });
      $(this.dataPartida.nativeElement).datepicker({
        dateFormat: "dd/mm/yy",
        minDate: new Date(),
        changeMonth: true,
        changeYear: false,  
        monthNamesShort: ['Janeiro','Fevereiro','Março','Abril','Maio','junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
        dayNamesMin: ['Dom','Seg','Ter','Qua','Qui','Sex','Sab'],
        monthNames: ['Janeiro','Fevereiro','Março','Abril','Maio','junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
        showOn: "both",
        buttonImageOnly: true,
        buttonImage: "/images/icons/calendar-01.svg", 
        onSelect: (value)=>{
        
        let data                   = $(this.dataPartida.nativeElement).val();
        this.dataItem.data_partida = data;
        $(this.dataChegada.nativeElement).datepicker("option","maxDate",data); 
                
        }
  
      });

    }

  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit(){
    this.setLabels();
    this.initDataItem();
  }
  /***
   * 
   * After
   * 
   * 
   **/
  ngAfterContentInit():void{
    setTimeout(() => {
      this.configDates();
    },500); 
  }

}
